import { PREPR_PAGE_TYPES } from '@constants/constants';
import { PreprCategories, PreprPage } from '@type-declarations/preprPage';

export type AlgoliaType =
  | 'Pagina: Activiteit'
  | 'Pagina: Activiteiten overzicht'
  | 'Pagina: Artikel overzicht'
  | 'Pagina: Artikel'
  | 'Pagina: Content'
  | 'Pagina: Evenement'
  | 'Pagina: Evenementen overzicht'
  | 'Pagina: Explore'
  | 'Pagina: Home'
  | 'Pagina: Landingspagina'
  | 'Pagina: Locatie overzicht'
  | 'Pagina: Locatie'
  | 'Pagina: Plattegrond'
  | 'Pagina: Route overzicht'
  | 'Pagina: Route'
  | 'Pagina: Zigzag Campagne'
  | 'Hoofd categorie'
  | 'Sub categorie'
  | 'Sub-sub categorie';

export function mapAlgoliaTypeToPreprType(
  model: AlgoliaType,
): PreprPage | PreprCategories {
  switch (model) {
    case 'Pagina: Artikel':
      return PREPR_PAGE_TYPES.NEWS_PAGE;
    case 'Pagina: Artikel overzicht':
      return PREPR_PAGE_TYPES.NEWS_OVERVIEW_PAGE;
    case 'Pagina: Activiteit':
      return PREPR_PAGE_TYPES.ACTIVITY_PAGE;
    case 'Pagina: Activiteiten overzicht':
      return PREPR_PAGE_TYPES.ACTIVITY_OVERVIEW_PAGE;
    case 'Pagina: Evenement':
      return PREPR_PAGE_TYPES.EVENT_PAGE;
    case 'Pagina: Evenementen overzicht':
      return PREPR_PAGE_TYPES.EVENT_OVERVIEW_PAGE;
    case 'Pagina: Explore':
      return PREPR_PAGE_TYPES.EXPLORE_PAGE;
    case 'Pagina: Home':
      return PREPR_PAGE_TYPES.HOME_PAGE;
    case 'Pagina: Landingspagina':
      return PREPR_PAGE_TYPES.LANDING_PAGE;
    case 'Pagina: Locatie':
      return PREPR_PAGE_TYPES.LOCATION_PAGE;
    case 'Pagina: Locatie overzicht':
      return PREPR_PAGE_TYPES.LOCATION_OVERVIEW_PAGE;
    case 'Pagina: Plattegrond':
      return PREPR_PAGE_TYPES.MAP_PAGE;
    case 'Pagina: Route':
      return PREPR_PAGE_TYPES.ROUTE_PAGE;
    case 'Pagina: Route overzicht':
      return PREPR_PAGE_TYPES.ROUTE_OVERVIEW_PAGE;
    case 'Pagina: Zigzag Campagne':
      return PREPR_PAGE_TYPES.ZIGZAG_CAMPAIGN_PAGE;
    case 'Hoofd categorie':
      return PREPR_PAGE_TYPES.MAIN_CATEGORY;
    case 'Sub categorie':
      return PREPR_PAGE_TYPES.SUB_CATEGORY;
    case 'Sub-sub categorie':
      return PREPR_PAGE_TYPES.SUB_SUB_CATEGORY;

    default:
      return PREPR_PAGE_TYPES.CONTENT_PAGE;
  }
}
